import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
import './PointAndMove.scss';
import { Arrow } from './constants';

const PointAndMove = (props) => {

    const [showQuestion, setShowQuestion] = useState(true);

    const getRotationValue = (direction) => {
        switch (direction) {
            case "up":
                return "-90deg";
            case "down":
                return "90deg";
            case "left":
                return "180deg";
            case "right":
                return "0deg"
        }
    }

    // const getStyle = () => {
    //     switch (props.specs?.moveDirection) {
    //         case "up":
    //             return 'up';
    //         case "down":
    //             return { top: "-100px", flexDirection: "column" };
    //         case "left":
    //             return 'left';
    //         case "right":
    //             return { left: "-100px", flexDirection: "column" };
    //     }
    // }

    // const getAnimate = () => {
    //     switch (props.specs?.moveDirection) {
    //         case "up":
    //             return { y: "-600px" };
    //         case "down":
    //             return { y: "600px" };
    //         case "left":
    //             return { x: "-600px" };
    //         case "right":
    //             return { x: "600px" };
    //     }
    // }

    useEffect(() => {
        setShowQuestion(false);
        setTimeout(() => setShowQuestion(true), 100);
    }, [props.specs]);

    const isVertical = props.specs?.moveDirection == 'up' || props.specs.moveDirection == 'down' ? 'vertical' : '';

    return (
        <div className="pointandmove-question">
            {showQuestion ? <React.Fragment>
                <div className={`arrows ${props.specs?.moveDirection}`}>
                    {[1, 2, 3].map(_ => (
                        <div>
                            <p>
                                <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                    <Arrow fill={props.specs.arrowColors} />
                                </div>
                            </p>
                        </div>

                    ))}

                </div>
                <div className={`arrows ${props.specs?.moveDirection} delay-animation ${isVertical}`}>
                    {[1, 2, 3].map(_ => (
                        <div>
                            <p>
                                <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                    <Arrow fill={props.specs.arrowColors} />
                                </div>
                            </p>
                        </div>

                    ))}

                </div>
                {!isVertical ?
                    <React.Fragment>
                        <div className={`arrows ${props.specs?.moveDirection} delay-animation-1`}>
                            {[1, 2, 3].map(_ => (
                                <div>
                                    <p>
                                        <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                            <Arrow fill={props.specs.arrowColors} />
                                        </div>
                                    </p>
                                </div>

                            ))}

                        </div>
                        <div className={`arrows ${props.specs?.moveDirection} delay-animation-2`}>
                            {[1, 2, 3].map(_ => (
                                <div>
                                    <p>
                                        <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                            <Arrow fill={props.specs.arrowColors} />
                                        </div>
                                    </p>
                                </div>

                            ))}

                        </div>
                    </React.Fragment> : null}
                {/* <div className={`arrows ${props.specs?.moveDirection} delay-animation-3`}>
                    {[1, 2, 3].map(_ => (
                        <div>
                            <p>
                                <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                    <Arrow fill={props.specs.arrowColors} />
                                </div>
                            </p>
                        </div>

                    ))}

                </div>
                <div className={`arrows ${props.specs?.moveDirection} delay-animation-4`}>
                    {[1, 2, 3].map(_ => (
                        <div>
                            <p>
                                <div style={{ transform: `rotate(${getRotationValue(props.specs?.arrowDirection)})` }}>
                                    <Arrow fill={props.specs.arrowColors} />
                                </div>
                            </p>
                        </div>

                    ))}

                </div> */}
            </React.Fragment> : null}

        </div>
    );
}

export default PointAndMove;
// {
//     type: levelNames.PONT_OR_MOVE,
//     specs: {
//         arrowColors: colors.red,
//         arrowDirection: 'left',
//         moveDirection: "right",
//         type: "moving",
//         answer: 3,
//         options: [
//             {
//                 name: "Up",
//                 value: 0,
//             },
//             {
//                 name: "Down",
//                 value: 1,
//             },
//             {
//                 name: "Left",
//                 value: 2,
//             },
//             {
//                 name: "Right",
//                 value: 2,
//             }
//         ]
//     }
// }